import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import cookie from 'js-cookie';
import InputMask from 'react-input-mask';
import T from '../Locale';
import { UserToUpdate, UserFields } from '../SignupForm.constants';
const { ADVISOR_ID } = UserFields;
const UserAdvisorStep = ({ partner, user, updateUser, errors }) => {
    const containerRef = useRef(null);
    const scrollDelayTimeout = null;
    const fieldAdvisor = partner.id + ADVISOR_ID;
    useEffect(() => {
        return () => {
            if (scrollDelayTimeout != null) {
                clearTimeout(scrollDelayTimeout);
            }
        };
    }, []);
    const setValueOnUser = useCallback((field, value, user) => {
        updateUser({ [field]: value }, user);
        if (field === ADVISOR_ID) {
            cookie.set(fieldAdvisor, value);
        }
    }, [user, updateUser]);
    return (_jsxs("div", Object.assign({ ref: containerRef, className: 'flex flex-col' }, { children: [_jsx("h3", Object.assign({ className: 'w-full text-center tailwind-reset text-3xl font-light' }, { children: T('partner.signup.branchAdvisorTitle') })), _jsx("div", Object.assign({ className: 'flex flex-col md:flex-row py-4' }, { children: _jsx("div", Object.assign({ className: 'w-full p:0 md:pr-5 mb-5 md:mb-0' }, { children: _jsxs("div", Object.assign({ className: `form-input ${(errors === null || errors === void 0 ? void 0 : errors.userFirstAdvisorId) != null ? 'form-input--error' : ''}` }, { children: [_jsx("label", Object.assign({ className: 'tailwind-reset font-light', htmlFor: fieldAdvisor }, { children: (errors === null || errors === void 0 ? void 0 : errors.userFirstAdvisorId) != null ? errors.userFirstAdvisorId : T('partner.signup.yourAdvisorId') })), _jsx(InputMask, { id: fieldAdvisor, mask: partner.mask, maskChar: '-', alwaysShowMask: true, defaultValue: user.advisorId, onChange: (event) => setValueOnUser('advisorId', event.target.value, UserToUpdate.BOTH), type: 'text' })] })) })) }))] })));
};
UserAdvisorStep.propTypes = {
    partner: PropTypes.shape({ branchQuestionActive: PropTypes.bool }).isRequired,
    user: PropTypes.object.isRequired,
    updateUser: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired
};
export default UserAdvisorStep;
